// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Tabs.module.scss  */
.Tabs-module-Root_3Zx {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 0.125rem; }

.Tabs-module-Container_-gx {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 32px; }

.Tabs-module-SliderContainer_1vm {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%; }

.Tabs-module-Slider_1MJ {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  user-select: none;
  pointer-events: none;
  transition: 0.3s ease-out; }

.Tabs-module-hasContainerCornersSquared_1Ww {
  border-radius: var(--tabs-container-border-radius-squared); }

.Tabs-module-hasContainerCornersRounded_2FJ {
  border-radius: var(--tabs-container-border-radius-rounded); }

.Tabs-module-hasContainerBackgroundNeutral_jxW {
  background: var(--tabs-container-filled-bg-color-neutral); }

.Tabs-module-hasContainerBackgroundLight_2u5 {
  background: var(--tabs-container-filled-bg-color-light); }

.Tabs-module-hasSliderBackgroundNeutral_2gk {
  background: var(--tabs-slider-filled-bg-color-neutral); }

.Tabs-module-hasSliderBackgroundLight_2CG {
  background: var(--tabs-slider-filled-bg-color-light); }

.Tabs-module-hasRoundedCorners_1XR {
  border-radius: var(--tabs-tab-rounded-border-radius); }

.Tabs-module-hasSquaredCorners_3MU {
  border-radius: var(--tabs-tab-squared-border-radius); }

.Tabs-module-hasUnderline_3Fa {
  border-bottom: 2px solid var(--tabs-colourful-underline-color); }

.Tabs-module-hasDisabledUnderline_1jk {
  border-bottom: 2px solid var(--tabs-colourful-underline-disabled-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Tabs/Tabs.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB,EAAE;;AAE7B;EACE,0DAA0D,EAAE;;AAE9D;EACE,0DAA0D,EAAE;;AAE9D;EACE,yDAAyD,EAAE;;AAE7D;EACE,uDAAuD,EAAE;;AAE3D;EACE,sDAAsD,EAAE;;AAE1D;EACE,oDAAoD,EAAE;;AAExD;EACE,oDAAoD,EAAE;;AAExD;EACE,oDAAoD,EAAE;;AAExD;EACE,8DAA8D,EAAE;;AAElE;EACE,uEAAuE,EAAE","sourcesContent":["/*  imported from Tabs.module.scss  */\n.Tabs-module-Root_3Zx {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  padding: 0.125rem; }\n\n.Tabs-module-Container_-gx {\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  min-height: 32px; }\n\n.Tabs-module-SliderContainer_1vm {\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%; }\n\n.Tabs-module-Slider_1MJ {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  pointer-events: none;\n  transition: 0.3s ease-out; }\n\n.Tabs-module-hasContainerCornersSquared_1Ww {\n  border-radius: var(--tabs-container-border-radius-squared); }\n\n.Tabs-module-hasContainerCornersRounded_2FJ {\n  border-radius: var(--tabs-container-border-radius-rounded); }\n\n.Tabs-module-hasContainerBackgroundNeutral_jxW {\n  background: var(--tabs-container-filled-bg-color-neutral); }\n\n.Tabs-module-hasContainerBackgroundLight_2u5 {\n  background: var(--tabs-container-filled-bg-color-light); }\n\n.Tabs-module-hasSliderBackgroundNeutral_2gk {\n  background: var(--tabs-slider-filled-bg-color-neutral); }\n\n.Tabs-module-hasSliderBackgroundLight_2CG {\n  background: var(--tabs-slider-filled-bg-color-light); }\n\n.Tabs-module-hasRoundedCorners_1XR {\n  border-radius: var(--tabs-tab-rounded-border-radius); }\n\n.Tabs-module-hasSquaredCorners_3MU {\n  border-radius: var(--tabs-tab-squared-border-radius); }\n\n.Tabs-module-hasUnderline_3Fa {\n  border-bottom: 2px solid var(--tabs-colourful-underline-color); }\n\n.Tabs-module-hasDisabledUnderline_1jk {\n  border-bottom: 2px solid var(--tabs-colourful-underline-disabled-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
